import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { bankTransactionsQueryOptions, SETTLED_STATUSES } from '@/features/bank-transactions/api'
import { BankTransactionsReport } from '@/features/bank-transactions/bank-transactions-report'
import {
  bankTxSearchSchema,
  type BankTxSearch,
  toBankTxListParams,
} from '@/features/bank-transactions/search'

export const Route = createFileRoute('/_authed/relatorios/contas-recebidas')({
  validateSearch: bankTxSearchSchema,
  loaderDeps: ({ search }) => ({
    params: toBankTxListParams(search, 'receivable', SETTLED_STATUSES),
  }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(bankTransactionsQueryOptions(deps.params)),
  component: Page,
})

function Page() {
  const { t } = useTranslation('nav')
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <BankTransactionsReport
      direction="receivable"
      statuses={SETTLED_STATUSES}
      showSettledColumn
      title={t('reports.received')}
      search={search}
      onSearchChange={(patch) => {
        // `to` EXPLÍCITO + `prev` ANOTADO: sem os dois o destino fica ambíguo, o
        // updater cai em `any` (TS7006) e a navegação pode virar no-op silencioso.
        void navigate({
          to: '/relatorios/contas-recebidas',
          search: (prev: BankTxSearch) => ({ ...prev, ...patch }),
          replace: true,
        })
      }}
    />
  )
}
